var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOzenLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 24,
    viewBox: "0 0 26 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.567 12.3748C20.567 7.66677 17.7216 3.33039 12.9794 3.33039C8.23711 3.33039 5.39175 7.66677 5.39175 12.3748C5.39175 17.0829 8.23711 21.4193 12.9794 21.4193C17.7216 21.4193 20.567 17.0829 20.567 12.3748ZM3 12.3748C3 6.88209 7.24742 3 12.9794 3C18.7113 3 23 6.92339 23 12.3748C23 17.8676 18.7113 21.7497 12.9794 21.7497C7.24742 21.791 3 17.8676 3 12.3748Z",
    fill: "#031C2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOzenLogo);
export default __webpack_public_path__ + "static/media/ozen-logo.fa93742369b87cb43a9bc8505685cf03.svg";
export { ForwardRef as ReactComponent };